import _ from 'underscore';

/**
 * As design required, legacy error alert will be shown as warning alert,
 * legacy info alert will be shown as confirmation alert.
 */
const levelMapping = {
  Error: 'Warning',
  Warning: 'Warning',
  Confirmation: 'Confirmation',
  Info: 'Confirmation',
};

export const mapAlertLevel = alert => _.extend(alert, { level: levelMapping[alert.level || 'Confirmation'] });

export const getUniqueAlertId = () => _.uniqueId('floating-banner-');
